/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkstationPartialUpdate
 */
export interface WorkstationPartialUpdate {
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof WorkstationPartialUpdate
     */
    report?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {string}
     * @memberof WorkstationPartialUpdate
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkstationPartialUpdate
     */
    hostname?: string;
    /**
     * 
     * @type {Date}
     * @memberof WorkstationPartialUpdate
     */
    lastSeen?: Date | null;
}

export function WorkstationPartialUpdateFromJSON(json: any): WorkstationPartialUpdate {
    return WorkstationPartialUpdateFromJSONTyped(json, false);
}

export function WorkstationPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkstationPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'report': !exists(json, 'report') ? undefined : json['report'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'hostname': !exists(json, 'hostname') ? undefined : json['hostname'],
        'lastSeen': !exists(json, 'last_seen') ? undefined : (json['last_seen'] === null ? null : new Date(json['last_seen'])),
    };
}

export function WorkstationPartialUpdateToJSON(value?: WorkstationPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'report': value.report,
        'name': value.name,
        'hostname': value.hostname,
        'last_seen': value.lastSeen === undefined ? undefined : (value.lastSeen === null ? null : value.lastSeen.toISOString()),
    };
}


